// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rbO02","name":"Header_name__2VWts","birthday":"Header_birthday__1QVYO","skeleton":"Header_skeleton__3F4pf"};